export default "__VITE_ASSET__D5XWmzup__"